module.exports = __webpack_public_path__ + "media/ConfluenceIntegration.15a773ecfb545dd24ebe77781c18bb3a.svg";